import type { PageFragment } from "../client/generated";
import { useProtectedImageSource } from "../client/images";
import { CSS_IN_TO_PX } from "./utils";
import { PageSkeleton } from "./PageSkeleton";

type Props = {
  fragment: PageFragment;
};

export function Page({ fragment }: Props) {
  const src = useProtectedImageSource(fragment.svgUrl);
  const pageWidth = fragment.width * CSS_IN_TO_PX;
  const pageHeight = fragment.height * CSS_IN_TO_PX;

  return (
    <div
      className="bg-white shadow-sm"
      style={{ width: `${pageWidth}px`, height: `${pageHeight}px` }}
    >
      {src ? (
        <img src={src} className="h-full" />
      ) : (
        <PageSkeleton fragment={fragment} />
      )}
    </div>
  );
}
